import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  container: {
    padding: "0 16px",
    background: "url(/assets/imgs/family/bg1.png) no-repeat",
    backgroundSize: "100% auto",
    backgroundPosition: "bottom",

    WebkitMaskImage:
      `-webkit-gradient(linear, left 95%, left bottom, from(${theme.design.color.border.black}), to(${theme.design.color.overlay.transparent}))`,

    maxWidth: 1920,
    margin: "auto",

    [theme.breakpoints.down("md")]: {
      backgroundSize: "auto 100%!important",
      backgroundPosition: "top center!important",
      WebkitMaskImage:
        `-webkit-gradient(linear, left 95%, left bottom, from(${theme.design.color.border.black}), to(${theme.design.color.overlay.transparent}))`,

      // WebkitMaskImage: "none",
    },
  },

  headerSection: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    alignItems: "center",
    paddingTop: 80,

    "& img": {
      height: 24,
    },

    "& div": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 16,
    },
  },

  headerTitle: {
    color: theme.design.color.text.primary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontSize: 20,
  },

  headerDescription: {
    color: theme.design.color.status.warning,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
  },

  headerChainLinkText: {
    color: theme.design.color.text.primary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
  },

  animationSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px 0",
    position: "relative",
    height: 240,
  },

  crate: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px 0",
    position: "absolute",
  },

  crateImage: {
    height: 160,
  },

  reel: {
    width: "100%",
    maxWidth: 1144,
    height: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    position: "absolute",

    overflow: "hidden",
    WebkitMaskImage:
      `radial-gradient(circle, ${theme.design.color.text.primary} 0%, ${theme.design.color.text.primary} 55%, ${theme.design.color.overlay.transparent} 80%)`,

    scale: 0,
    opacity: 0,
  },

  reelStop: {
    width: 2,
    height: "120px",
    position: "absolute",
    left: "50%",
    top: "50%",
    translate: "-50% -50%",
    background: theme.design.color.status.danger,
  },

  prizeItemList: {
    display: "flex",
    gap: 16,
  },

  prizeItem: {
    background: theme.design.color.surface.subtle,
    border: "1px solid",
    borderColor: theme.design.color.border.black,
    borderRadius: 8,
    padding: 12,
    boxShadow:
      theme.design.shadow.insetStrong,

    "& img": {
      width: 60,
      height: 60,
    },
  },

  purchaseSection: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "32px 0",
    gap: 16,
  },

  openButton: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: 8,

    "& button": {
      background: theme.design.color.action.primary,

      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      textTransform: "none",

      borderRadius: 8,
      padding: "8px 32px",
      border: "1px solid",
      borderColor: theme.design.color.border.default,
    },
    "& img": {
      width: 24,
      height: 24,
    },
  },

  purchaseButton: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: 8,

    "& button": {
      background: theme.design.color.overlay.transparent,

      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      textTransform: "none",

      borderRadius: 8,
      padding: "8px 32px",
      border: "1px solid",
      borderColor: theme.design.color.border.default,
    },
  },

  priceDescription: {
    display: "flex",
    gap: 8,
    alignItems: "center",

    "& img": {
      width: 20,
      height: 20,
    },

    "& p": {
      color: theme.design.color.text.secondary,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      fontSize: 14,
    },
  },

  selectCombo: {},
}));

export default styles;
